import React from 'react';
import { AlertTriangleIcon, ClockIcon, FileSignatureIcon, InboxIcon, MapIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { dispatchFeatures } from '../data/content';
import { Reveal } from './showcase/Reveal';
const icons = {
  map: MapIcon,
  clock: ClockIcon,
  alert: AlertTriangleIcon,
  users: UsersIcon,
  shield: ShieldCheckIcon,
  inbox: InboxIcon,
  signature: FileSignatureIcon
};
interface DispatchBrainProps {
  eyebrow?: string;
  title?: string;
}
export function DispatchBrain({
  eyebrow = 'Inside the system',
  title = 'Not an answering machine. A dispatch brain for your team.'
}: DispatchBrainProps) {
  return <section id="dispatch" aria-labelledby="dispatch-title" className="border-b border-white/5 bg-ink-900" data-id="element-70" data-mp="107aqrgj2qz1b">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-71" data-mp="1a34dfsqic8wt">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-72" data-mp="154jahljvfb4o">
          {eyebrow}
        </p>
        <h2 id="dispatch-title" className="mt-5 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-73" data-mp="1y6gxpck0qytt">
          {title}
        </h2>

        <div className="mt-12 grid gap-px overflow-hidden rounded-xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-74" data-mp="276dnjhi5a3qg">
          {dispatchFeatures.map((feature, index) => {
          const Icon = icons[feature.icon];
          return <Reveal key={feature.title} delay={0.06 * index} offset={12} className="h-full" data-id="element-75" data-mp="2h2yu479tbmwe" data-mpi={index}>
                <div className="h-full bg-ink-800 p-7" data-id="element-76" data-mp="2qvedn90rcjje">
                  <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-77" data-mp="2uwzl2euiw5m7" />
                  <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-white" data-id="element-78" data-mp="2uyao2cg599c9">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-79" data-mp="34vfa8c9zp4t2">
                    {feature.body}
                  </p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}